import request from '@/plugins/axios'

// เข้าสู่ระบบ
export const apiLogin = (data: any) => request.post('/login/account', data)

// ออกจากระบบ
export const apiLogout = () => request.get('/login/logout')

// การกำหนดค่า
export const apiconfig = () => request.get('/settings.platform/getConfig')

// ออกจากระบบ
export const apiDownLoad = () => request.get('', {params: {d: 1}})


// รายการข้ามหน้า
export const apiLinkList = (params: any) => request.get('/theme.DecorateThemePage/getshoppage',{params})

// รายการข้ามหน้า
export const apiPcLinkList = (params: any) => request.get('/theme.PcDecorateThemePage/getPcpage',{params})

// รายการสิทธิ์
export const apiAuth = () => request.get('/config/getAuth',)



/** S การจัดการวัสดุ **/

// เพิ่มการจัดหมวดหมู่ไฟล์
export const apiFileAddCate = (params:any) => request.post('/file/addCate', params)

// แก้ไขการจัดหมวดหมู่ไฟล์
export const apiFileEditCate = (params:any) => request.post('/file/editCate', params)

// ลบหมวดหมู่ไฟล์
export const apiFileDelCate = (params: { id: number }) => request.post('/file/delCate', params)

// รายการจำแนกประเภทไฟล์
export const apiFileListCate = (params: any) => request.get('/file/listCate', { params })

// รายการไฟล์
export const apiFileList = (params: any) => request.get('/file/lists', { params })

// การลบไฟล์
export const apiFileDel = (params: {ids: any []}) => request.post('/file/delete', params)

// การเคลื่อนไหวของไฟล์
export const apiFileMove = (params: {ids: any [], cid: number}) => request.post('/file/move', params)

// เปลี่ยนชื่อไฟล์
export const apiFileRename = (params: {id: number, name: string}) => request.post('file/rename', params)

/** E การจัดการวัสดุ **/